export const CanvasLockType = {
  LockMovementX: 'lockMovementX',
  LockMovementY: 'lockMovementY',
  HasControls: 'hasControls',
  Evented: 'evented'
};
